module.exports = __webpack_public_path__ + "static/media/clear_chart.76a7642e.svg";